import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { UiExecutionSettingsModule } from '@components/ui-execution-settings/ui-execution-settings.module';
import { TranslateModule } from '@ngx-translate/core';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

import { ProvisionRobotComponent } from './provision-robot.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        MatIconModule,
        MatInputModule,
        MatSlideToggleModule,
        MatRadioModule,
        MatFormFieldModule,
        UiNgLetModule,
        TranslateModule,
        UiExecutionSettingsModule,
        UiContentLoaderModule,
    ],
    declarations: [
        ProvisionRobotComponent,
    ],
    exports: [
        ProvisionRobotComponent,
    ],
})
export class ProvisionRobotModule { }
